import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { getSites, queryKeys, staleTimes } from "@/api";
import { useAudienceContext } from "@/context";
import { useToken } from "@/hooks/core";
import { Site } from "@/types";
import { unwrap } from "@/utils";

const NO_SITES: Site[] = [];

export const useSites = () => {
  const getToken = useToken();

  // const client = process.env.REACT_APP_CLIENT || 'core';
  const client = 'imedia';

  const { data, isLoading, isError } = useQuery({
    queryKey: queryKeys.sites(client),
    queryFn: async () => unwrap(await getSites(await getToken(), client)) ?? [],
    staleTime: staleTimes.sites,
  });

  return { sites: data ?? NO_SITES, loading: isLoading, error: isError };
};


export const useSelectedSites = (sites: Site[]) => {
  const state = useAudienceContext();

  const siteMap = useMemo(() => {
    return new Map((sites || []).map((s) => [s.site_id, s]));
  }, [sites]);

  // Extract the site ids
  const site_ids = state.currentAudience?.audience_type === 'site'
    ? state.currentAudience.site_config.sites
    : undefined;
  const site_ids_key =(site_ids || []).join(',');

  return useMemo(() => {
    if (!site_ids_key || siteMap.size === 0) return [];

    return site_ids_key.split(',').map(Number)
      .map((id) => siteMap.get(id))
      .filter((site): site is Site => Boolean(site));
  }, [site_ids_key, siteMap]);

}

